//#region src/createModuleFederationConfig.ts
var createModuleFederationConfig = (options)=>{
    return options;
};
//#endregion
exports.createModuleFederationConfig = createModuleFederationConfig; //# sourceMappingURL=createModuleFederationConfig.cjs.map
